import React from "react";

// Use lazy loading for components
const AlternativeInvestmentsHub = React.lazy(
  () =>
    import(
      "../pages/portfolio-management/alternative-assets/AlternativeInvestmentsHub"
    ),
);
const AlternativeInvestmentsList = React.lazy(
  () =>
    import(
      "../pages/portfolio-management/alternative-assets/AlternativeInvestmentsList"
    ),
);
const Artwork = React.lazy(
  () => import("../pages/portfolio-management/alternative-assets/Artwork"),
);
const Collectibles = React.lazy(
  () => import("../pages/portfolio-management/alternative-assets/Collectibles"),
);
const FundDetails = React.lazy(
  () => import("../pages/portfolio-management/alternative-assets/FundDetails"),
);
const HedgingOpportunities = React.lazy(
  () =>
    import(
      "../pages/portfolio-management/alternative-assets/HedgingOpportunities"
    ),
);
const Miscellaneous = React.lazy(
  () =>
    import("../pages/portfolio-management/alternative-assets/Miscellaneous"),
);
const PrivateEquity = React.lazy(
  () =>
    import("../pages/portfolio-management/alternative-assets/PrivateEquity"),
);
const RealEstate = React.lazy(
  () => import("../pages/portfolio-management/alternative-assets/RealEstate"),
);
const StructuredNotes = React.lazy(
  () =>
    import("../pages/portfolio-management/alternative-assets/StructuredNotes"),
);

const alternativeInvestmentRoutes = [
  {
    path: "/portfolio-management/alternative-assets",
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <AlternativeInvestmentsHub />
      </React.Suspense>
    ),
  },
  {
    path: "/portfolio-management/alternative-assets/list",
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <AlternativeInvestmentsList />
      </React.Suspense>
    ),
  },
  {
    path: "/portfolio-management/alternative-assets/artwork",
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <Artwork />
      </React.Suspense>
    ),
  },
  {
    path: "/portfolio-management/alternative-assets/collectibles",
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <Collectibles />
      </React.Suspense>
    ),
  },
  {
    path: "/portfolio-management/alternative-assets/fund-details",
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <FundDetails />
      </React.Suspense>
    ),
  },
  {
    path: "/portfolio-management/alternative-assets/hedging",
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <HedgingOpportunities />
      </React.Suspense>
    ),
  },
  {
    path: "/portfolio-management/alternative-assets/miscellaneous",
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <Miscellaneous />
      </React.Suspense>
    ),
  },
  {
    path: "/portfolio-management/alternative-assets/private-equity",
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <PrivateEquity />
      </React.Suspense>
    ),
  },
  {
    path: "/portfolio-management/alternative-assets/real-estate",
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <RealEstate />
      </React.Suspense>
    ),
  },
  {
    path: "/portfolio-management/alternative-assets/structured-notes",
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <StructuredNotes />
      </React.Suspense>
    ),
  },
];

export default alternativeInvestmentRoutes;
